import { Alert, AlertDescription, AlertTitle } from "./ui/alert";

interface ValidationBannerProps {
	message: string;
	/** Optional list of specific field errors */
	fields?: string[];
	/** Optional aria-live for screen reader announcements */
	"aria-live"?: "polite" | "assertive";
}

const ValidationBanner: React.FC<ValidationBannerProps> = ({
	message,
	fields,
	"aria-live": ariaLive,
}) => {
	return (
		<Alert variant="destructive" aria-live={ariaLive}>
			<AlertTitle>{message}</AlertTitle>
			{fields && fields.length > 0 && (
				<AlertDescription>
					<ul className="mt-1 list-disc pl-4">
						{fields.map((field) => (
							<li key={field}>{field}</li>
						))}
					</ul>
				</AlertDescription>
			)}
		</Alert>
	);
};

export default ValidationBanner;
